/**
 * Resolved gateway base URL. When `VITE_BLUEBIRD_GATEWAY_URL` is unset,
 * we assume the frontend is served from the same origin as the Worker
 * (the production layout — `apps/cloudflare/` binds `apps/web/dist/`
 * via wrangler's `[assets]`). In dev the env var points at the
 * deployed Worker, e.g. `https://leibniz-bluebird-internal.gygeslabs.workers.dev`.
 */
export function gatewayBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_BLUEBIRD_GATEWAY_URL?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
}

/**
 * Host (no scheme) for the partysocket WebSocket connection. partysocket
 * derives the WS scheme from the current page (ws/wss).
 */
export function gatewayHost(): string {
  const url = new URL(gatewayBaseUrl());
  return url.host;
}

/**
 * Whether the gateway is on the same origin as the page (and therefore
 * fetches don't need explicit CORS handling).
 */
export function isSameOrigin(): boolean {
  if (typeof window === 'undefined') return true;
  try {
    return new URL(gatewayBaseUrl()).origin === window.location.origin;
  } catch {
    return false;
  }
}

export const CLERK_PUBLISHABLE_KEY = import.meta.env
  .VITE_CLERK_PUBLISHABLE_KEY as string | undefined;
